import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Dialog, DialogContent, Box, Typography, Button,
} from '@mui/material';
import { LockReset } from '@mui/icons-material';
import { logout } from '../../store/authSlice';

export default function SessionExpiredModal() {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const sessionExpired = useSelector((state) => state.auth.sessionExpired);

  const handleReLogin = () => {
    dispatch(logout());
    navigate('/login', { replace: true });
  };

  return (
    <Dialog
      open={sessionExpired}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      // Prevent closing by clicking backdrop
      onClose={() => {}}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          p: 0.5,
          textAlign: 'center',
        },
      }}
    >
      <DialogContent sx={{ px: 4, py: 4 }}>
        {/* Icon */}
        <Box
          sx={{
            width: 64, height: 64, borderRadius: '50%',
            bgcolor: '#FEF2F2',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            mx: 'auto', mb: 2.5,
          }}
        >
          <LockReset sx={{ fontSize: 32, color: '#EF4444' }} />
        </Box>

        {/* Title */}
        <Typography sx={{ fontSize: '1.1rem', fontWeight: 800, color: '#1E293B', mb: 1 }}>
          Session Ended
        </Typography>

        {/* Message */}
        <Typography sx={{ fontSize: '0.85rem', color: '#64748B', lineHeight: 1.6, mb: 3 }}>
          Your terminal session was ended by a manager.
          Any in-progress bill has been saved as a hold order.
          Please log in again to continue.
        </Typography>

        {/* CTA */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleReLogin}
          disableElevation
          sx={{
            bgcolor: '#4F46E5', color: '#fff',
            py: 1.3, fontSize: '0.9rem', fontWeight: 700,
            borderRadius: '10px', textTransform: 'none',
            '&:hover': { bgcolor: '#4338CA' },
          }}
        >
          Back to Login
        </Button>
      </DialogContent>
    </Dialog>
  );
}
